<script lang="ts">
	import { ScriptSceneSection } from '@Shelly/scenes-script';
	import { SidepanelContent } from '@Shelly/shelly-design-system/index';
	import ActiveTimePreview from 'src/components/Scenes/SceneDrawSections/ActiveTimePreview.svelte';
	import MorePreview from 'src/components/Scenes/SceneDrawSections/MorePreview.svelte';
	import { createEventDispatcher } from 'svelte';

	export let scene;

	const dispatch = createEventDispatcher();
</script>

<SidepanelContent>
	<ScriptSceneSection
		{scene}
		activeTimeComponent={ActiveTimePreview}
		morePreviewComponent={MorePreview}
		on:sceneConvertedToScript={(e) => dispatch('scene-converted-to-script', e.detail)}
	/>
</SidepanelContent>
